/* upgrade-area.js: the trade-in area gate (patch 2.02; changes/2.02-tradein-area-gate.md). Listens in the capture phase for the
   clicks that start or place a trade-in; the money files are not touched. Fails open: if this throws, the click goes through. */
(function () {
  'use strict';
  var W = window, D = document, H = D.documentElement, KEY = 'ug.area.v1', OK = /^(cairo|giza|other)$/, mem = '';
  var HOOKS = [
    ['[data-ug-deal-order]', 'order'],
    ['#ug-tradein-summary button.ug-btn--primary', 'order'],
    ['[data-ug-pdp-addcart],[data-ug-pdp-sticky-addcart]', 'pdp'],   // an order only while a valuation is live on that phone
    ['.ug-sell-cta-row>a.ug-btn--secondary', 'start']                // the sell page's trade-up link
  ];
  var sheet, scrim, tpl, cur, busy, redo, cssOn;
  function q(s, r) { return (r || D).querySelector(s); }

  function get() {
    var v = mem;
    try { v = W.sessionStorage.getItem(KEY) || ''; } catch (e) { /* private mode: memory */ }
    return OK.test(v) ? v : '';
  }
  function set(v) {
    mem = v;
    try { W.sessionStorage.setItem(KEY, v); } catch (e) { /* private mode */ }
    D.dispatchEvent(new CustomEvent('ug:area', { detail: v }));
  }
  function match(t) {
    var i, el;
    for (i = 0; t && t.closest && i < HOOKS.length; i++) {
      el = t.closest(HOOKS[i][0]);
      if (el) { return { el: el, sel: HOOKS[i][0], kind: HOOKS[i][1] }; }
    }
  }
  function live(b) {   // upgrade-pdp.js's own test for "this Add to cart is an order with a trade-in"
    var d = W.UpgradeDeal, s = d && d.get && d.get(), id = b.getAttribute('data-variant-id');
    return !!(s && s.tradein && s.target && id && String(s.target.variantId) === id && d.order && d.orderProperties && d.orderProperties(s.target));
  }
  function record(area) {   // always resolves: a failed or slow write never stops the order
    return new Promise(function (done) {
      var t = setTimeout(done, 4000), r = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
      function fin() { clearTimeout(t); done(); }
      try {
        W.fetch(r.replace(/\/?$/, '/') + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { _ti_area: area } })
        }).then(fin, fin);
      } catch (e) { fin(); }
    });
  }
  function replay(m) {   // the same click once more, past this gate
    var el = D.contains(m.el) ? m.el : q(m.sel);
    busy = cur = 0;
    if (el) { redo = 1; try { el.click(); } finally { redo = 0; } }
  }
  function proceed(m, area) {   // in the zone: an order is recorded first, the ds busy bar on the button meanwhile
    var el = m.el;
    if (m.kind === 'start') { return replay(m); }
    el.style.setProperty('--ug-btn-w', el.offsetWidth + 'px'); el.setAttribute('aria-busy', 'true');
    record(area).then(function () { el.removeAttribute('aria-busy'); el.style.removeProperty('--ug-btn-w'); replay(m); });
  }
  function onClick(e) {
    var m, a;
    if (redo) { return; }
    try {
      m = match(e.target);
      if (!m || (m.kind === 'pdp' && !live(m.el))) { return; }
      e.preventDefault(); e.stopImmediatePropagation();
      if (busy) { return; }
      busy = 1; cur = m; a = get();
      if (a === 'cairo' || a === 'giza') { proceed(m, a); } else { open(a ? 'oz' : 'ask'); }
    } catch (err) { if (m && !redo) { replay(m); } }
  }

  /* the sheet: the 2.0 .ug-sheet, cloned from the template in layout/theme.liquid on first need */
  function open(v) {
    var u, l;
    tpl = tpl || D.getElementById('ug-area-tpl');
    u = tpl.getAttribute('data-css');
    function show() {
      try {
        if (!sheet) {
          D.body.appendChild(tpl.content.cloneNode(true));
          sheet = q('[data-ug-area-sheet]'); scrim = q('[data-ug-area-scrim]');
          sheet.addEventListener('click', onSheet); scrim.addEventListener('click', dismiss);
        }
        [].forEach.call(D.body.children, function (s) {   // everything behind the sheet is out of reach
          if (s !== sheet && s !== scrim && !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(s.tagName) && !s.inert) { s.inert = true; s.setAttribute('data-ug-area-inert', ''); }
        });
        H.classList.add('ug-lock');
        sheet.setAttribute('data-view', v);
        void sheet.offsetWidth;   // flush, so the slide runs
        sheet.classList.add('is-open'); scrim.classList.add('is-open');
        view(v);
      } catch (err) { if (cur) { replay(cur); } }
    }
    function go() { if (!cssOn) { cssOn = 1; show(); } }
    if (cssOn || q('link[href="' + u + '"]')) { cssOn = 1; return show(); }   // the trade-in page links it; elsewhere it is added now
    l = D.createElement('link'); l.rel = 'stylesheet'; l.href = u; l.onload = l.onerror = go;
    D.head.appendChild(l);
    setTimeout(function () { if (busy) { go(); } }, 1500);
  }
  function view(v, first) {
    sheet.setAttribute('data-view', v);
    try { (v === 'oz' ? q('[data-ug-area-msg]', sheet) : first ? q('[data-ug-do=cairo]', sheet) : sheet).focus({ preventScroll: true }); } catch (e) { /* hidden */ }
  }
  function close(m) {   // focus returns to what was pressed, or to the card when that has gone
    var el = m && (D.contains(m.el) ? m.el : q(m.sel));
    sheet.classList.remove('is-open'); scrim.classList.remove('is-open'); H.classList.remove('ug-lock');
    [].forEach.call(D.querySelectorAll('[data-ug-area-inert]'), function (s) { s.inert = false; s.removeAttribute('data-ug-area-inert'); });
    el = el && !el.closest('[inert]') ? el : q('[data-ug-area-card] input:checked,[data-ug-area-card] input');
    if (el) { el.focus({ preventScroll: true }); }
  }
  function dismiss() { var m = cur; close(m); busy = cur = 0; }   // Esc, the X, the scrim: the action is cancelled
  function away(a) {   // "Buy without trade-in": the valuation goes, so nothing downstream carries a trade-in. Returns the phone's page, else the shop
    var d = W.UpgradeDeal, s = d && d.get && d.get(), h = a.getAttribute('data-shop') || a.getAttribute('href');
    a.setAttribute('data-shop', h);
    try { if (s && s.target && d.targetHref) { h = d.targetHref(s.target); } } catch (e) { /* the shop */ }
    if (d && d.clearTradein) { d.clearTradein(); }
    return h;
  }
  function onSheet(e) {
    var t = e.target.closest && e.target.closest('[data-ug-do]'), v = t && t.getAttribute('data-ug-do'), m = cur, h;
    if (!t) { return; }
    if (v === 'x') { return dismiss(); }
    if (v === 'change') { return view('ask', 1); }
    if (v === 'buy') {
      h = away(t);
      if (m && m.kind === 'pdp') { e.preventDefault(); close(m); return replay(m); }   // this page's Add to cart, now a plain add
      if (m && m.kind === 'start') { h = m.el.getAttribute('href'); }
      if (m && h.split('?')[0] === location.pathname) { e.preventDefault(); return dismiss(); }   // already on that page
      t.setAttribute('href', h);
      return dismiss();   // the link then goes on its way
    }
    set(v);
    if (v === 'other') { return view('oz'); }
    close(m);
    if (m) { proceed(m, v); }
  }
  D.addEventListener('keydown', function (e) {
    var f, i;
    if (!sheet || !sheet.classList.contains('is-open')) { return; }
    if (e.key === 'Escape') { e.preventDefault(); return dismiss(); }
    if (e.key !== 'Tab') { return; }
    f = [].filter.call(sheet.querySelectorAll('button,a[href]'), function (x) { return x.getClientRects().length; });
    i = f.indexOf(D.activeElement);
    if (e.shiftKey ? i <= 0 : i === f.length - 1) { e.preventDefault(); f[e.shiftKey ? f.length - 1 : 0].focus(); }
  });

  /* the card on the trade-in page */
  function card(c) {
    var radios = [].slice.call(c.querySelectorAll('input[name="ug-area"]')), eng = c.parentNode.querySelector('.ug-engine'),
        say = q('[data-ug-area-live]', c), msg = q('.ug-area-ask__msg', c), buy = q('[data-ug-do=buy]', c);
    function paint(talk) {
      var a = get();
      c.setAttribute('data-state', a);
      radios.forEach(function (r) { r.checked = r.value === a; });
      if (eng) { eng.inert = a === 'other'; if (a === 'other') { eng.setAttribute('aria-disabled', 'true'); } else { eng.removeAttribute('aria-disabled'); } }
      say.textContent = talk && a === 'other' ? msg.textContent : '';
    }
    function pick() { return q('input:checked', c) || radios[0]; }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { set(r.value); });
      if (r.checked && !get()) { set(r.value); }   // pressed before this script ran
    });
    c.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-ug-do]');
      if (t === buy) { buy.setAttribute('href', away(buy)); } else if (t) { pick().focus(); }
    });
    D.addEventListener('ug:area', function () { paint(1); });
    W.addEventListener('pageshow', function (e) { if (e.persisted) { paint(); } });
    paint();
  }

  W.UpgradeArea = { get: get, set: set };
  D.addEventListener('click', onClick, true);
  try { var c = q('[data-ug-area-card]'); if (c) { card(c); } } catch (err) { /* the page is the page it was */ }
})();
